import { Modal, DatePicker, Card, Select, Row, Col, Table } from "antd";
import dayjs from "dayjs";

import PlotGraphics from "../../../context/share/PlotGraphics";

import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import requets from "../../../api";
import { convertValue } from "../helpers/conversion-rules";
import { useAppAuth } from "../../../context/use-app-auth";

const { RangePicker } = DatePicker;
const currentDate = dayjs();
const startOfMonth = dayjs().startOf("month");

const pickerConfig = {
  RANGE: {
    Component: RangePicker,
    props: {
      defaultValue: [startOfMonth, currentDate],
      picker: undefined,
    },
  },
  YEAR: {
    Component: DatePicker,
    props: {
      defaultValue: currentDate,
      picker: "year",
    },
  },
  MONTH: {
    Component: DatePicker,
    props: {
      defaultValue: currentDate,
      picker: "month",
    },
  },
  DAY: {
    Component: DatePicker,
    props: {
      defaultValue: currentDate,
      picker: "day",
    },
  },
};

const type = {
  RANGE: "RANGE",
};

const fields = {
  "lamp.current": "current",
  "lamp.factorPower": "power_factor",
  "lamp.power": "power",
  "lamp.voltage": "voltage",
  "lamp.energy": "energy_accumulated",
  "lamp.frequency": "frequency",
};
const loading = {
  LOADING: true,
  FINISHED: false,
};

export const ModalGraphics = ({ dataModal, setDataModal }) => {
  const { t } = useTranslation("global");
  const auth = useAppAuth();
  const req = requets(auth.user?.access_token);

  const [typeReportGraphi, setTypeReportGraphi] = useState(type.RANGE);

  const [data, setData] = useState([]);

  const [unit, setUnit] = useState("");

  const [dateRange, setDateRange] = useState([
    dayjs().subtract(3, "days").toISOString(),
    dayjs().toISOString(),
  ]);
  const [loadingMeasurement, setLoadingMeasurement] = useState(
    loading.FINISHED
  );

  useEffect(() => {
    if (!dataModal.title) return;

    fetchMeasurementByDevEui();
  }, [dataModal, dateRange, typeReportGraphi]);

  const options = [
    {
      label: t("lamp.range"),
      value: type.RANGE,
    },
    // {
    //   label: t("lamp.diary"),
    //   value: type.DAY,
    // },
    // {
    //   label: t("lamp.month"),
    //   value: type.MONTH,
    // },
    // {
    //   label: t("lamp.year"),
    //   value: type.YEAR,
    // },
  ];

  const queryParamsMap = {
    [type.RANGE]: (dates) => {
      const [start, stop] = dates;
      return `start=${start}&stop=${stop}`;
    },
  };

  async function fetchMeasurementByDevEui() {
    setLoadingMeasurement(loading.LOADING);
    const queryParams = queryParamsMap[typeReportGraphi](dateRange);
    const devEui = dataModal.device.devEui;

    await req
      .get(
        `/metrics/${devEui}/history?field=${dataModal.measurement}&${queryParams}`
      )
      .then((response) => {
        if (response.status === 200) {
          // Response: { fields: [{ field, count, data: [{value, timestamp}], unit }] }
          const fields = response.data?.fields ?? [];
          const targetField =
            fields.find((f) => f.field === dataModal.measurement) ?? fields[0];
          const rawData = targetField?.data ?? [];
          const fieldUnit = targetField?.unit ?? "";

          const dataWithConvertedValues = rawData.map((point) => {
            const { value, unit } = convertValue(point.value, fieldUnit);
            return {
              date: dayjs(point.timestamp).format("YYYY-MM-DD HH:mm"),
              value,
              unit,
            };
          });

          if (dataWithConvertedValues.length === 0) {
            setData([]);
            setUnit("");
            return;
          }
          setUnit(dataWithConvertedValues[0].unit || "");
          setData(dataWithConvertedValues);
        }
      })
      .finally(() => setLoadingMeasurement(loading.FINISHED));
  }

  const handleChangeDate = (dateRange) => {
    if (!dateRange || dateRange.length < 2) return;

    const [start, end] = dateRange;

    const formattedRange = [start.toISOString(), end.toISOString()];

    setDateRange(formattedRange);
  };

  return (
    <Modal
      maskClosable={false}
      title={dataModal.t(dataModal.title)}
      centered
      open={dataModal.open}
      onOk={() => setDataModal({ ...dataModal, open: !dataModal.open })}
      onCancel={() => setDataModal({ ...dataModal, open: !dataModal.open })}
      width={800}
    >
      <Card>
        <Row gutter={[16, 32]}>
          {/* <Col span={24}>
            {dataModal?.title === "lamp.energy" && (
              <Table
                columns={columns}
                dataSource={dataSumary}
                pagination={false}
              />
            )}
          </Col> */}
          <Col span={12}>
            <DatePickerControl
              typeReportGraphi={typeReportGraphi}
              handleChangeDate={handleChangeDate}
              t={dataModal.t}
            />
          </Col>
          {/* <Col span={12}>
            <Select
              defaultValue={type.MONTH}
              onChange={handleChangeTypeGraphi}
              options={options}
              size="large"
              style={{
                width: "100%",
              }}
            />
          </Col> */}
        </Row>
      </Card>
      <PlotGraphics data={data} unit={unit} />
    </Modal>
  );
};

const DatePickerControl = ({ typeReportGraphi, handleChangeDate, t }) => {
  const { Component, props } = pickerConfig[typeReportGraphi] || {};

  if (!Component) return null;

  return (
    <Component
      size="large"
      style={{ width: "100%" }}
      onChange={handleChangeDate}
      placeholder={[
        t("controlPanel.startDate"),
        typeReportGraphi === "RANGE" && t("controlPanel.endDate"),
      ].filter(Boolean)}
      {...props}
    />
  );
};

export function calculateConsumption(data) {
  const dataReducer = data.reduce((acc, item) => {
    const date = dayjs(item.formatt_date).format("YYYY-MM-DD");
    const energyAccumulated = item["energy_accumulated"];

    if (!acc[date]) {
      acc[date] = {
        date,
        startEnergy: energyAccumulated,
        endEnergy: energyAccumulated,
      };
    } else {
      acc[date].endEnergy = energyAccumulated;
    }

    return acc;
  }, {});

  const dailyConsumption = Object.keys(dataReducer).map((date) => {
    const { startEnergy, endEnergy } = dataReducer[date];
    const consumedEnergy = endEnergy - startEnergy;
    return { date, scales: consumedEnergy };
  });

  return Object.values(dailyConsumption);
}
